import { render, staticRenderFns } from "./TableHeaders.vue?vue&type=template&id=f2eaf582&scoped=true"
import script from "./TableHeaders.vue?vue&type=script&lang=ts"
export * from "./TableHeaders.vue?vue&type=script&lang=ts"
import style0 from "./TableHeaders.vue?vue&type=style&index=0&id=f2eaf582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2eaf582",
  null
  
)

export default component.exports